import { Templates } from './templates';
import { IRenderer } from '../renderer';
import { DataEntryHistoryDescriptor } from '../../../modules/dataentry.history/model/dataentry.history';
import { DataEntryProcessingStateMap } from '../../../modules/dataentry/model/dataentry';

export class DataEntryHistoryRenderer implements IRenderer {
  RenderHeader(preview: any) {
    if (preview as DataEntryHistoryDescriptor) {
      const history = preview as DataEntryHistoryDescriptor;
      return '<a>' + 'Adatszolgáltatás Történet' + '</a>';
    }
    return '<b>invalid databinding</b>';
  }
  RenderBody(preview: any) {
    let html = '<ul class="bulletless">';
    if (preview as DataEntryHistoryDescriptor) {
      const history = preview as DataEntryHistoryDescriptor;
      if (history.profileFullName) {
        html += Templates.listItem('Létrehozó:', history.profileFullName);
      }
      if (history.createdOn) {
        let historyAsString = history.createdOn.toString();

        const date = new Date(historyAsString);
        historyAsString = date.toLocaleDateString('hu-HU') + ' ' + date.toLocaleTimeString('hu-HU');

        html += Templates.listItem('Létrehozás dátuma:', historyAsString);
      }
      if (history.message) {
        if (history.message.length < 30) {
          html += Templates.listItem('Üzenet:', history.message);
        } else {
          history.message = history.message.substring(0, 30) + '...';

          html += Templates.listItem('Üzenet:', history.message);
        }
      }
      if (history.previousState) {
        const prevStateMap = DataEntryProcessingStateMap[history.previousState];

        html += Templates.listItem('Korábbi állapot:', prevStateMap.name);
      }
      if (history.currentState) {
        const currStateMap = DataEntryProcessingStateMap[history.currentState];

        html += Templates.listItem('Módosított állapot:', currStateMap.name);
      }
    }
    html += '</ul>';
    return html;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/preview.service/renderers/dataentry.history.renderer.ts